import React from 'react';
import styled from 'styled-components';
import { secToLabel, addMinutesLabel, repeatLabel } from '../../lib/raceConflict';

/* 경기 스케줄 목록.
   상세: docs/race/제타트랙_레이스모드_작업계획서.md §6.1 */

const Scroll = styled.div`overflow-x: auto;`;

const Table = styled.table`
  width: 100%; border-collapse: collapse; min-width: 860px;

  th, td { padding: 11px 12px; font-size: 14px; text-align: left; border-bottom: 1px solid #f3f4f6; }
  th { background: #f8f9fa; color: #374151; font-weight: 600; font-size: 13px; white-space: nowrap; }
  tbody tr:hover { background: #fafafa; }
`;

const Tr = styled.tr`
  opacity: ${(p) => p.off ? 0.45 : 1};
`;

const Time = styled.td`font-variant-numeric: tabular-nums; white-space: nowrap;`;

const Dist = styled.span`
  display: inline-block; padding: 2px 8px; border-radius: 5px;
  font-size: 13px; font-weight: 600;
  background: ${(p) => p.tone.bg}; color: ${(p) => p.tone.fg};
`;

const Prize = styled.td`
  font-variant-numeric: tabular-nums; white-space: nowrap;
  i { color: #d1d5db; font-style: normal; margin: 0 4px; }
`;

const Switch = styled.label`
  display: inline-flex; align-items: center; cursor: pointer;
  input { width: 16px; height: 16px; accent-color: #2563eb; cursor: pointer; }
`;

const Button = styled.button`
  padding: 5px 11px; font-size: 13px; border-radius: 6px; cursor: pointer;
  color: ${(p) => p.danger ? '#b91c1c' : '#374151'};
  background: #fff;
  border: 1px solid ${(p) => p.danger ? '#fca5a5' : '#e5e7eb'};
  &:hover { background: ${(p) => p.danger ? '#fef2f2' : '#f8f9fa'}; }
  & + & { margin-left: 5px; }
`;

const Empty = styled.div`padding: 44px 0; text-align: center; color: #9ca3af; font-size: 14px;`;

const TONES = [
  { max: 1000, bg: '#e8f1fd', fg: '#1e4e8c' },
  { max: 2500, bg: '#e6f7f1', fg: '#0f6e56' },
  { max: Infinity, bg: '#f3ecfb', fg: '#4b2c73' },
];
const toneOf = (m) => TONES.find((t) => Number(m) <= t.max);

const RaceScheduleList = ({ schedules, onToggle, onEdit, onDelete }) => {
  if (!schedules || schedules.length === 0) {
    return <Empty>등록된 경기가 없습니다. 위의 <b>＋ 경기 추가</b> 로 만들어보세요.</Empty>;
  }

  return (
    <Scroll>
      <Table>
        <thead>
          <tr>
            <th style={{ width: 52 }}>사용</th>
            <th style={{ width: 78 }}>시간</th>
            <th style={{ width: 110 }}>거리</th>
            <th style={{ width: 74 }}>종료</th>
            <th style={{ width: 130 }}>반복</th>
            <th style={{ width: 70 }}>최소</th>
            <th>상금 (1등 · 2등 · 3등)</th>
            <th style={{ width: 108 }} />
          </tr>
        </thead>
        <tbody>
          {schedules.map((r) => {
            const off = Number(r.active) === 0;
            return (
              <Tr key={r.clubRaceScheduleID} off={off}>
                <td>
                  <Switch>
                    <input
                      type="checkbox"
                      checked={!off}
                      aria-label={`${secToLabel(r.startTime)} ${r.distance}m 사용`}
                      onChange={(e) => onToggle(r, e.target.checked ? 1 : 0)}
                    />
                  </Switch>
                </td>
                <Time>{secToLabel(r.startTime)}</Time>
                <td><Dist tone={toneOf(r.distance)}>{Number(r.distance).toLocaleString()}m</Dist></td>
                <Time>{addMinutesLabel(r.startTime, r.endMin)}</Time>
                <td>{repeatLabel(r)}</td>
                <td>{Number(r.minMember)}명</td>
                <Prize>
                  {Number(r.prize1).toLocaleString()}P <i>·</i>
                  {Number(r.prize2).toLocaleString()}P <i>·</i>
                  {Number(r.prize3).toLocaleString()}P
                </Prize>
                <td style={{ whiteSpace: 'nowrap' }}>
                  <Button onClick={() => onEdit(r)}>수정</Button>
                  <Button danger onClick={() => onDelete(r)}>삭제</Button>
                </td>
              </Tr>
            );
          })}
        </tbody>
      </Table>
    </Scroll>
  );
};

export default RaceScheduleList;
